import Vue from 'vue';
import VueRouter from 'vue-router';
import MainPage from './components/MainPage.vue'
import MainPageStandalone from './components/MainPageStandalone.vue'
import AuthorizationError from './components/AuthorizationError.vue';
import NotFoundError from './components/NotFoundError.vue';
import StandaloneTaskRedirect from './components/StandaloneTaskRedirect.vue';
import store1 from './store.js';
import constantMessages from "./messages";

Vue.use(VueRouter);
const store = store1;
const router = new VueRouter({
	mode: 'history',
	linkActiveClass: 'active',
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		};
	},

	routes: [
		{
			path: '/',
      		redirect: '/category/view/Home',
		},
		{
			path: process.env.VUE_APP_CONTEXT_PATH + '/usersgroups/usersAPI/:redirectTo',
			redirect: process.env.VUE_APP_CONTEXT_PATH + '/unauthorizedError'
		},
		{
			path: process.env.VUE_APP_CONTEXT_PATH,
			component: MainPage,
			children: [
				{
					path: "login",
					name: 'LoginPage',
					component: () => import("./components/login/LoginPage.vue"),
				},
				{
					path: "processengine",
					component: () => import("./components/design/DefaultRoute.vue"),
					meta: {
						requireRoleAuth: true,
						roleToCheck: "RoleProcessAdmin"
					},
					children: [
						{
							path: "deployment",
							name: "DeploymentList",
							component: () => import("./components/processEngine/deployment/DeploymentList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.deployments"] }
						},
						{
							path: "deployment/:id",
							name: "DeploymentEdit",
							component: () => import("./components/processEngine/deployment/DeploymentEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.deployments"] }
						},
						{
							path: "processdefinitions",
							name: "DefinitionList",
							component: () => import("./components/processEngine/definitions/DefinitionsList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.definations"] }
						},
						{
							path: 'processdefinitions/:defId',
							name: 'DefinitionEdit',
							component: () => import("./components/processEngine/definitions/DefinitionEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.definations"] }
						},
						{
							path: "tasks",
							name: "Tasks",
							component: () => import("./components/processEngine/tasks/TaskList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.tasks"] }
						},
						{
							path: "processes",
							name: "InstanceList",
							component: () => import("./components/processEngine/instances/InstanceList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.instances"] }
						},
						{
							path: "processes/processinstance/:instId/:menu",
							name: "ProcessInstanceScreen",
							component: () => import("./components/processEngine/instances/ProcessInstanceScreen.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.instances"] }
						},
						{
							path: "tasks/:taskId",
							name: "ViewProcessEngineTask",
							component: () => import("./components/deployTasks/ViewTask.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.task.edit"] }
						},
						{
							path: "processFailure",
							name: "ProcessErrorList",
							component: () => import("./components/processEngine/processErrors/ProcessErrorList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.errors"] }
						},
						{
							path: "jobs",
							name: "JobList",
							component: () => import("./components/processEngine/jobs/JobList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.jobs"] }
						},
						{
							path: 'jobs/:jobId',
							name: 'JobEdit',
							component: () => import("./components/processEngine/jobs/JobEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.jobs"] }
						},
						{
							path: "tasks/customview/:customViewId",
							name: "CustomViewTask",
							component: () => import("./components/processEngine/tasks/CustomViewTask.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.task.create"] }
						},
						{
							path: "tasks/customview/:customViewId/copy",
							name: "CustomViewTask",
							component: () => import("./components/processEngine/tasks/CustomViewTask.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.task.create"] }
						},
						{
							path: "processes/customview/:customViewId",
							name: "CustomViewProcess",
							component: () => import("./components/processEngine/instances/CustomViewProcess.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.instance.create"] }
						},
						{
							path: "processes/customview/:customViewId/copy",
							name: "CustomViewProcess",
							component: () => import("./components/processEngine/instances/CustomViewProcess.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.instance.create"] }
						}
					]
				},
				{
					path: "design",
					component: () => import("./components/design/DefaultRoute.vue"),
					meta: {
						requireRoleAuth: true,
						roleToCheck: "RoleDesign"
					},
					children: [
						{
							path: "applications",
							name: 'ApplicationHome',
							component: () => import("./components/design/applications/ApplicationHome.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.applications"] }
						},
						{
							path: "formTemplates",
							name: 'FormTemplates',
							component: () => import("./components/design/templates/TemplateList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.formTemplates"] }
						},
						{
							path: "formTemplates/:templateId",
							name: 'FormTemplateCreate',
							component: () => import("./components/design/templates/FormTemplateCreate.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.formTemplates.create"] }
						},
						{
							path: "emailTemplates",
							name: 'EmailTemplates',
							component: () => import("./components/design/templates/TemplateList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.emailTemplates"] }
						},
						{
							path: "globalProcessProperties",
							name: 'GlobalProcessProperties',
							component: () => import("./components/design/GlobalProcessProperties.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.globalProperties"] }
						},
						{
							path: "emailTemplates/:templateId",
							name: 'EmailTemplateCreate',
							component: () => import("./components/design/templates/EmailTemplateCreate.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.emailTemplates.create"] }
						},
						{
							path: "emailTemplates/:templateId/copy",
							name: 'EmailTemplateCopy',
							component: () => import("./components/design/templates/EmailTemplateCreate.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.emailTemplates.create"] }
						},
						{
							path: "applications/new",
							name: 'ApplicationCreate',
							component: () => import("./components/design/applications/ApplicationCreate.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.applications.create"] }
						},
						{
							path: "applications/appprocesses",
							name: 'ApplicationProcessList',
							component: () => import("./components/design/processes/ApplicationProcessList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.processes"] }
						},
						{
							path: "applications/appprocesses/copy",
							name: 'MultipleProcessCopy',
							component: () => import("./components/design/processes/MultipleProcessCopy.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.processes.create"] }
						},
						{
							path: 'applications/:appId',
							name: 'ApplicationEdit',
							component: () => import("./components/design/applications/ApplicationEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.applications.create"] }
						},
						{
							path: "forms",
							name: 'ApplicationForms',
							component: () => import("./components/design/forms/ApplicationForms.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.forms"] }
						},
						{
							path: 'applications/:appId/appprocesses/create',
							name: 'ApplicationProcessCreate',
							component: () => import("./components/design/processes/ApplicationProcessCreate.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.processes.create"] }
						},
						{
							path: 'applications/:appId/appforms/create',
							name: 'ApplicationFormCreate',
							component: () => import("./components/design/forms/ApplicationFormCreate.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.forms.create"] }
						},
						{
							path: "applications/appforms/copy",
							name: 'MultipleFormCopy',
							component: () => import("./components/design/forms/MultipleFormsCopy.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.forms.create"] }
						},
						{
							path: 'applications/:appId/appprocesses/:processId',
							name: 'ApplicationProcessEdit',
							component: () => import("./components/design/processes/ApplicationProcessEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.processes.create"] }
						},
						{
							path: 'applications/:appId/appforms/:formId',
							name: 'ApplicationFormEdit',
							component: () => import("./components/design/forms/ApplicationFormEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.forms.create"] }
						},
						{
							path: 'applications/:appId/copy',
							name: 'ApplicationCopy',
							component: () => import("./components/design/applications/ApplicationCopy.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.applications.create"] }
						},
						{
							path: "customdatalist",
							name: 'CustomDataList',
							component: () => import("./components/design/customdatalist/CustomDataList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.dataList"] }
						},
						{
							path: 'customDataList/:dataListId',
							name: 'CustomDataListCreate',
							component: () => import("./components/design/customdatalist/CustomDataListCreate.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.dataList.create"] }
						},
						{
							path: 'categories',
							name: 'CategoryEdit',
							component: () => import("./components/design/categories/CategoryEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.categories"] }
						}

					]
				},
				{
					path: "processes",
					component: () => import("./components/design/DefaultRoute.vue"),
					meta: {
						requireRoleAuth: true,
						roleToCheck: "RoleUser"
					},
					children: [
						{
							path: "startedbyme",
							name: "StartedByMe",
							component: () => import("./components/myProcesses/MyProcessList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.processes.startedByMe"] }
						},
						{
							path: "involvingme",
							name: "InvolvingMe",
							component: () => import("./components/myProcesses/MyProcessList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.processes.allInvolved"] }
						},
						{
							path: "drafts",
							name: "DraftProcessList",
							component: () => import("./components/myProcesses/DraftProcessList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.processes.draftProcess"] }
						},
						{
							path: "viewprocess/:definitionId",
							name: "ViewProcess",
							component: () => import("./components/deployProcesses/ViewProcess.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.processes"] }
						},
						{
							path: "processinstance/:instId/:menu",
							name: "UserProcessInstanceScreen",
							component: () => import("./components/processEngine/instances/ProcessInstanceScreen.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.processes"] }
						}
					]
				},
				{
					path: "user",
					component: () => import("./components/design/DefaultRoute.vue"),
					meta: {
						requireRoleAuth: true,
						roleToCheck: "RoleUser"
					},
					children: [
						{
							path: "dashboard",
							name: "UserDashboard",
							component: () => import("./components/administration/dashboard/UserDashboard.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.user.dashboard"] }
						},
						{
							path: "profile",
							name: "UserProfile",
							component: () => import("./components/usersgroups/users/UserProfile.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.user.profile"] }
						},
					]
				},
				{
					path: "tasks",
					component: () => import("./components/design/DefaultRoute.vue"),
					meta: {
						requireRoleAuth: true,
						roleToCheck: "RoleUser"
					},
					children: [
						{
							path: "assigned",
							name: "Assigned",
							component: () => import("./components/myTasks/MyTaskList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.tasks.assigned"] }
						},
						{
							path: "unclaimed",
							name: "Unclaimed",
							component: () => import("./components/myTasks/MyTaskList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.tasks.unclaimed"] }
						},
						{
							path: "involvingme",
							name: "InvolvingMeTasks",
							component: () => import("./components/myTasks/MyTaskList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.tasks.allInvolved"] }
						},
						{
							path: "drafts",
							name: "DraftTaskList",
							component: () => import("./components/myTasks/DraftTaskList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.tasks.draftTask"] }
						},
						{
							path: "viewtask/:menuLocation/:taskId",
							name: "ViewTask",
							component: () => import("./components/deployTasks/ViewTask.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.task.edit"] }
						}
					]
				},
				{
					path: "category",
					component: () => import("./components/design/DefaultRoute.vue"),
					meta: {
						requireRoleAuth: true,
						roleToCheck: "RoleUser"
					},
					children: [
						{
							path: "view/:categoryName",
							name: "DeployedProcesses",
							component: () => import("./components/deployProcesses/DeployedProcesses.vue"),
						}
					]
				},
				{
					path: "processengine",
					component: () => import("./components/design/DefaultRoute.vue"),
					meta: {
						requireRoleAuth: true,
						roleToCheck: "RoleAdmin"
					},
					children: [
						{
							path: "deployment",
							name: "DeploymentList",
							component: () => import("./components/processEngine/deployment/DeploymentList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.deployments"] }
						},
						{
							path: "deployment/:id",
							name: "DeploymentEdit",
							component: () => import("./components/processEngine/deployment/DeploymentEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.deployments"] }
						},
						{
							path: "processdefinitions",
							name: "DefinitionList",
							component: () => import("./components/processEngine/definitions/DefinitionsList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.definations"] }
						},
						{
							path: 'processdefinitions/:defId',
							name: 'DefinitionEdit',
							component: () => import("./components/processEngine/definitions/DefinitionEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.definations"] }
						},
						{
							path: "tasks",
							name: "Tasks",
							component: () => import("./components/processEngine/tasks/TaskList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.tasks"] }
						},
						{
							path: "processes",
							name: "InstanceList",
							component: () => import("./components/processEngine/instances/InstanceList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.instances"] }
						},
						{
							path: "processes/processinstance/:instId/:menu",
							name: "ProcessInstanceScreen",
							component: () => import("./components/processEngine/instances/ProcessInstanceScreen.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.instances"] }
						},
						{
							path: "tasks/:taskId",
							name: "ViewProcessEngineTask",
							component: () => import("./components/deployTasks/ViewTask.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.task.edit"] }
						},
						{
							path: "processFailure",
							name: "ProcessErrorList",
							component: () => import("./components/processEngine/processErrors/ProcessErrorList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.errors"] }
						},
						{
							path: "jobs",
							name: "JobList",
							component: () => import("./components/processEngine/jobs/JobList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.jobs"] }
						},
						{
							path: 'jobs/:jobId',
							name: 'JobEdit',
							component: () => import("./components/processEngine/jobs/JobEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.jobs"] }
						},
						{
							path: "tasks/customview/:customViewId",
							name: "CustomViewTask",
							component: () => import("./components/processEngine/tasks/CustomViewTask.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.task.create"] }
						},
						{
							path: "tasks/customview/:customViewId/copy",
							name: "CustomViewTaskCopy",
							component: () => import("./components/processEngine/tasks/CustomViewTask.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.task.create"] }
						},
						{
							path: "processes/customview/:customViewId",
							name: "CustomViewProcess",
							component: () => import("./components/processEngine/instances/CustomViewProcess.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.instance.create"] }
						},
						{
							path: "processes/customview/:customViewId/copy",
							name: "CustomViewProcessCopy",
							component: () => import("./components/processEngine/instances/CustomViewProcess.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.instance.create"] }
						}
					]
				}, {
					path: "usersgroups",
					component: () => import("./components/design/DefaultRoute.vue"),
					meta: {
						requireRoleAuth: true,
						roleToCheck: "RoleUserAdmin"
					},
					children: [
						{
							path: "groups",
							name: "GroupList",
							component: () => import("./components/usersgroups/groups/GroupList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.usergroups.groups"] }
						},
						{
							path: "hierarchies/:id",
							name: "GroupHierarchyEdit",
							component: () => import("./components/usersgroups/hierarchies/GroupHierarchyEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.usergroups.hierarchyCreate"] }
						},
						{
							path: "hierarchies",
							name: "GroupHierarchyList",
							component: () => import("./components/usersgroups/hierarchies/GroupHierarchyList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.usergroups.hierarchies"] }
						},

						{
							path: "userProperties",
							name: "UserPropertyList",
							component: () => import("./components/usersgroups/userproperties/UserPropertyList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.usergroups.userProps"] }
						},
						{
							path: "users",
							name: "UserList",
							component: () => import("./components/usersgroups/users/UserList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.usergroups.users"] }
						},
						{
							path: "users/:userId",
							name: "UserEdit",
							component: () => import("./components/usersgroups/users/UserEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.usergroups.users"] }
						},
						{
							path: "groups/:groupId",
							name: "GroupEdit",
							component: () => import("./components/usersgroups/groups/GroupEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.usergroups.groups"] }
						}, 
						{
							path: "userImport",
							name: "UserImport",
							component: () => import("./components/usersgroups/users/UserImport.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.usergroups.users.import"] }
						},
						{
							path: "userProperties/:userPropId",
							name: "UserPropertyEdit",
							component: () => import("./components/usersgroups/userproperties/UserPropertyEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.usergroups.userPropCreate"] }
						},
					]
				}, {
					path: "integrate",
					component: () => import("./components/design/DefaultRoute.vue"),
					meta: {
						requireRoleAuth: true,
						roleToCheck: "RoleIntegration"
					},
					children: [
						{
							path: "externalsystems",
							name: "ExternalSystemList",
							component: () => import("./components/integrate/externalSystems/ExternalSystemList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.integrate.externalSysList"] }
						},
						{
							path: "externalsystems/new",
							name: 'ExternalsystemCreate',
							component: () => import("./components/integrate/externalSystems/ExternalSystemCreate.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.integrate.externalSysCreate"] }
						},
						{
							path: "externalsystems/:externalSystemId",
							name: 'ExternalsystemEdit',
							component: () => import("./components/integrate/externalSystems/ExternalSystemEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.integrate.externalSysList"] }
						},
						{
							path: "externalsystems/:externalSystemId/apis/new",
							name: 'ExternalSystemAPICreate',
							component: () => import("./components/integrate/externalSystems/ExternalSystemAPICreate.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.integrate.externalSysCreate"] }
						},
						{
							path: "externalsystems/:externalSystemId/apis/:apiId",
							name: 'ExternalSystemAPIEdit',
							component: () => import("./components/integrate/externalSystems/ExternalSystemAPIEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.integrate.externalSysList"] }
						},
						{
							path: "externalsystems/:externalSystemId/apis/:apiId/fileadapters/:fileadapterid",
							name: 'FileAdapterEdit',
							component: () => import("./components/integrate/externalSystems/FileAdapterEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.integrate.fileAdapter.create"] }
						}, 
						{
							path: "externalsystems/:externalSystemId/apis/:apiId/file/:connectionId",
							name: 'FileConnectionEdit',
							component: () => import("./components/integrate/externalSystems/FileConnectionEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.integrate.fileConn.create"] }
						},
						{
							path: "externalsystems/:externalSystemId/apis/:apiId/rest/:connectionId",
							name: 'RestConnectionEdit',
							component: () => import("./components/integrate/externalSystems/RestConnectionEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.integrate.restConn.create"] }
						},
						{
							path: "externalsystems/:externalSystemId/apis/:apiId/database/:connectionId",
							name: 'DatabaseConnectionEdit',
							component: () => import("./components/integrate/externalSystems/DatabaseConnectionEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.integrate.dbConn.create"] }
						},
						{
							path: "externalsystems/:externalSystemId/apis/:apiId/sqladapters/:sqladapterId",
							name: 'SqlAdapterEdit',
							component: () => import("./components/integrate/externalSystems/SqlAdapterEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.integrate.sqlAdapter.create"] }
						},
						{
							path: "externalsystems/:externalSystemId/apis/:apiId/restadapters/:restadapterId",
							name: 'RestAdapterEdit',
							component: () => import("./components/integrate/externalSystems/RestAdapterEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.integrate.restAdapter.create"] }
						},

					]
				}, 
				{
					path: "usersgroups",
					component: () => import("./components/design/DefaultRoute.vue"),
					meta: {
						requireRoleAuth: true,
						roleToCheck: "RoleAdmin"
					},
					children: [
						{
							path: "roles",
							name: "RoleList",
							component: () => import("./components/usersgroups/roles/RoleList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.usergroups.roles"] }
						}, 
						{
							path: "roles/:roleName",
							name: "RoleEdit",
							component: () => import("./components/usersgroups/roles/RoleEdit.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.usergroups.roles"] }
						}
					]
				},
				{
					path: "admin",
					component: () => import("./components/design/DefaultRoute.vue"),
					meta: {
						requireRoleAuth: true,
						roleToCheck: "RoleAdmin"
					},
					children: [
						{
							path: "dashboard",
							name: "AdminDashboard",
							component: () => import("./components/administration/dashboard/AdminDashboard.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.admin.dashboard"] }
						},
						{
							path: "settings",
							name: "AdminSettings",
							component: () => import("./components/administration/settings/AdminSettings.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.admin.settings"] }
						},
						{
							path: "themes",
							name: "AdminThemes",
							component: () => import("./components/administration/themes/AdminThemes.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.admin.themes"] }
						},
						{
							path: "audit",
							name: "AuditHistoryList",
							component: () => import("./components/administration/audit/AuditHistoryList.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.admin.auditHist"] }
						},
						{
							path: "audit/revision/:revisionNumber",
							name: 'RevisionDetail',
							component: () => import("./components/administration/audit/RevisionDetail.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.admin.auditHist"] }
						},
						{
							path: "audit/entityHistory/:entityName",
							name: 'AuditHistoryEntity',
							component: () => import("./components/administration/audit/AuditHistoryEntity.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.admin.auditHist"] }
						},
						{
							path: "importexport",
							name: "ImportExport",
							component: () => import("./components/administration/importexport/ImportExport.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.admin.impexp"] }
						},
						{
							path: "systemTemplates",
							name: "SystemTemplates",
							component: () => import("./components/administration/systemtemplates/SystemTemplates.vue"),
							meta: { title: constantMessages.PAGEHEADER_TITLE["menu.admin.sysTemplates"] }
						}
					]
				}
			]
		},
		{
			path: process.env.VUE_APP_CONTEXT_PATH + '/:standalone/:external/:processOrTask',
			component: MainPageStandalone,
			children: [
				{
					path: "viewprocess/:definitionId",
					name: "StandaloneViewProcess",
					component: () => import("./components/deployProcesses/ViewProcess.vue"),
					meta: { title: constantMessages.PAGEHEADER_TITLE["menu.design.processes"] }
				},

				{
					path: "viewtask/:taskId",
					name: "StandaloneViewTask",
					component: () => import("./components/deployTasks/ViewTask.vue"),
					meta: { title: constantMessages.PAGEHEADER_TITLE["menu.process.engine.task.edit"] }
				},
				{
					path: "success",
					name: "StartSuccess",
					component: () => import("./components/deployProcesses/StartSuccess.vue"),
				}
			]
		},
		{
			path: process.env.VUE_APP_CONTEXT_PATH + '/applications/:applicationId/appforms/:formId/formdesigner',
			name: 'ApplicationFormDesigner',
			meta: {
				requireRoleAuth: true,
				roleToCheck: "RoleDesign"
			},
			component: () => import("./components/FormDesigner.vue")
		},
		{
			path: process.env.VUE_APP_CONTEXT_PATH + '/applications/:applicationId/appprocesses/:processId/modeller',
			name: 'ApplicationProcessModeller',
			meta: {
				requireRoleAuth: true,
				roleToCheck: "RoleDesign"
			},
			component: () => import("./components/Modeller.vue")
		},
		{
			path: process.env.VUE_APP_CONTEXT_PATH + '/templates/form-template/:formTemplateId/form-designer',
			name: 'FormTemplateModeller',
			meta: {
				requireRoleAuth: true,
				roleToCheck: "RoleDesign"
			},
			component: () => import("./components/FormDesigner.vue")
		},
		{
			path: process.env.VUE_APP_CONTEXT_PATH + '/unauthorizedError',
			name: 'AuthorizationError',
			component: AuthorizationError
		},
		{
			path: process.env.VUE_APP_CONTEXT_PATH+'/applications/*',
			name: 'AuthorizationError',
			component: AuthorizationError
		},
		{
			path: '*',
			name: 'NotFoundError',
			component: NotFoundError
		},
		{
			path: process.env.VUE_APP_CONTEXT_PATH + '/notFound',
			name: 'NotFoundError',
			component: NotFoundError
		},
		{
			path: process.env.VUE_APP_CONTEXT_PATH  + '/redirectTo/:taskId',
			name: 'StandaloneTaskRedirect',
			component: StandaloneTaskRedirect
		},
		{
			path: process.env.VUE_APP_CONTEXT_PATH + '/applicationError',
			component: () => import("./components/ApplicationError.vue")
		},
		{
			path: process.env.VUE_APP_CONTEXT_PATH + '/sessionLogout',
			component: () => import("./components/SessionLogout.vue")
		},
	]
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requireRoleAuth)) {
        if (!store.getters.getIsUserLogin) {
			// not logged in so redirect to login page with the return url
			localStorage.setItem(
				"returnUrl", to.fullPath.replace(to.hash,"")
			);
			window.location = process.env.VUE_APP_CONTEXT_PATH + "/login";
			return false;
		}
		// check if route is restricted by role (This logic is removed as per MWPAP-16438)
		// MWPAP-16438 check if route is restricted by license
		// MWPAP-16768 - added && (and) conditions for role and license checks
		// License checks removed - licenses are now optional, only role checks remain
		if (to.matched.some(record => record.meta.roleToCheck)) {
			var roleName = to.matched.slice().reverse().find(r => r.meta && r.meta.roleToCheck).meta.roleToCheck;
			var hasRole = false;
            switch (roleName) {
                case "RoleAdmin":
					hasRole = store.getters.getRoleAdmin;
                    break;
                case "RoleDesign":
					hasRole = store.getters.getRoleDesign;
                    break;
                case "RoleIntegration":
					hasRole = store.getters.getRoleIntegration;
                    break;
                case "RoleProcessAdmin":
					hasRole = store.getters.getRoleProcessAdmin;
                    break;
                case "RoleUser":
					hasRole = store.getters.getRoleUser;
                    break;
                case "RoleUserAdmin":
					hasRole = store.getters.getRoleUserAdmin;
                    break;
                case "RoleFullAPI":
					hasRole = store.getters.getRoleFullAPI;
                    break;
                default:
                    break;
            }
            if(!hasRole){
				return next(process.env.VUE_APP_CONTEXT_PATH + "/unauthorizedError");
			}
			// MWPAP-16768 changes end
		}
    }
    next();
});
const DEFAULT_TITLE = 'BPM Application';
router.afterEach((to, from) => {
    Vue.nextTick(() => {
		let pageTitle = to.meta.title;
		if(store.getters.getThemeData && store.getters.getThemeData.productName && pageTitle) {
			pageTitle += ' - ' + store.getters.getThemeData.productName;
		}
        document.title = pageTitle || DEFAULT_TITLE;
    });
});

export default router;
